import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { useRouter } from "next/router";

import SideModal from "components/SideModal";
import SellOrders from "./SellOrders";
import AcceptOrder from "./AcceptOrder";
import SellOrderForm from "./SellOrderForm";
import WalletOverview from "./WalletOverview";
import SellOrderOverview from "./SellOrderOverview";
import OTP from "./OTP";
import OrderSuccess from "components/SharesOrder/OrderSuccess";
import OrderExpired from "components/SharesOrder/OrderExpired";
import { RenderAdequacyStep } from "components/AdequacyModal";
import TimeOutCountDown from "components/TimeOutCountDown";
import FormatDateWithLocale from "components/FormatDateWithLocale";
import { setInvestmentStepData } from "store/user/investment/actions";
import { setAdequacyStart } from "store/user/adequacy/actions";
import { userDashboardDetailsSuccess } from "store/user/account/actions";
import { selectAdequacyStep, selectAdequacyIsAccepted } from "store/user/adequacy/selectors";
import { selectUserDashboardDetails } from "store/user/account/selectors";
import { HIDE_ADEQUACY_TILE_STATUS_STEP, ORDER_TYPE, ACCEPT_SPLIT_ORDER_TYPE, KYC_STATUS_LOCAL_HIDE } from "constants/index";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import { acceptOrder } from "api";

import CloseIcon from "assets/images/svg/close-icon.svg";
import NewLoader from "components/NewLoader";
import { selectCurrenKYCStatus } from "store/user/kyc/selectors";

const messages = {
    soSuccessSubheading: "sales_offer_created_successfully",
    soSuccessOfferAcceptSubheading: "successfully_accept_purchase_offer",
    soEditSuccesslineBelowImage: "change_sales_offer",
    soSuccessOfferAcceptlineBelowImage: "sell_being_made",
    soSuccessOfferAcceptTitle: "what_next",
    soSuccessOfferAcceptContent: "transaction_submitted_processed",
    sellingFee: "selling_fee",
    totalSalesPrice: "total_sales_price",
    boEditSuccessButtonText: "close_btn",
    addMoreTimeTitle1: "addMore_time_title1",
    addMoreTimeTitle2: "activity_detail_sender_suffix",
    addMoreTimeContent: "addMore_time_content",
    addMoreTimeButtonText: "addMore_time_button_text",
};

const SellSharesModal = ({
    open,
    onCloseButtonClick,
    adequacyStep,
    isAccepted,
    userDashboardDetails,
    setInvestmentStepData,
    setAdequacyStart,
    userDashboardDetailsSuccess,
    project,
    projectTokenData,
    onCreate,
    userProjectShares,
    isUserProjectShares,
    projectOffers,
    minShareTypeWise,
    maxInvestmentAmount,
    currentKYCStatus,
}) => {
    useSideModalScrollToTop();

    const router = useRouter();
    const { formatMessage } = useFormattedMessage();

    const [backSlideEffect, setBackSlideEffect] = useState("");

    const [step, setStep] = useState("sellOrders");
    const [closeTitle, setCloseTitle] = useState("");
    const [isOfferAccepted, setOfferAccepted] = useState(false);
    const [orderStepData, setOrderStepData] = useState({});

    const [orderTimeout, setOrderTimeout] = useState("");
    const [isTimerVisible, setTimerVisible] = useState(false);
    const [isAddMoreTimeVisible, setAddMoreTimeVisible] = useState(false);
    const [isAddTimeLoading, setAddTimeLoading] = useState(false);
    const [timeoutExtended, setTimeoutExtended] = useState(false);
    const [currentOrderUID, setCurrentOrderUID] = useState("");

    const StatusAdequacy = userDashboardDetails?.StatusAdequacy;

    const isKycCompleted = !!KYC_STATUS_LOCAL_HIDE.find((status) => status === currentKYCStatus);
    const isAdequacyCompleted = !!HIDE_ADEQUACY_TILE_STATUS_STEP.find((status) => status === StatusAdequacy);

    useEffect(() => {
        setTimerVisible(!!(orderTimeout && isOfferAccepted));
    }, [orderTimeout, isOfferAccepted]);

    useEffect(() => {
        if (isAddMoreTimeVisible) {
            jQuery(".side-modal").animate({ scrollTop: 0 });
            jQuery(".add-more-time").slideDown();
        } else {
            jQuery(".add-more-time").slideUp();
        }
    }, [isAddMoreTimeVisible]);

    const setStepAndData = (nextStepData) => {
        setOrderStepData({ ...orderStepData, ...nextStepData });
    };

    const resetTimerThings = () => {
        setOrderTimeout("");
        setTimerVisible(false);
        setAddMoreTimeVisible(false);
        setTimeoutExtended(false);
        setCurrentOrderUID("");
    };

    const reset = () => {
        setStep("sellOrders");
        setOfferAccepted(false);
        setOrderStepData({});
        resetTimerThings();
    };

    const close = () => {
        onCloseButtonClick();
        isAdequacyCompleted && setAdequacyStart({ step: 1 });
        reset();
    };

    const hideAddTimeBlock = () => {
        setAddMoreTimeVisible(false);
        setTimeoutExtended(true);
    };

    const addMoreTime = async () => {
        try {
            setAddTimeLoading(true);
            const res = currentOrderUID && (await acceptOrder({ order: { uid: currentOrderUID } }));
            res && setAddTimeLoading(false);

            if (!res || res.errors || res.data.errors || res.data.data.errors) return;

            const order = res?.data?.data?.acceptOrder?.order;
            order && setOrderTimeout(order.OrderTimeout);
            hideAddTimeBlock();
        } catch {
            setAddTimeLoading(false);
        }
    };

    const renderStep = (step) => {
        switch (step) {
            case "sellOrders":
                return (
                    <SellOrders
                        minShareTypeWise={minShareTypeWise}
                        maxInvestmentAmount={maxInvestmentAmount}
                        backSlideEffect={backSlideEffect}
                        userProjectShares={userProjectShares}
                        isUserProjectShares={isUserProjectShares}
                        getBuyOrders={open}
                        project={project}
                        setCloseTitle={setCloseTitle}
                        setOfferAccepted={setOfferAccepted}
                        setStepAndData={setStepAndData}
                        onAcceptOffer={(values) => {
                            setBackSlideEffect("step-slide-left");

                            const total = parseInt(values.shares) * parseFloat(values.pricePerShare);
                            const sellingFeePercent = 0;
                            const sellingFee = sellingFeePercent > 0 ? (sellingFeePercent * total) / 100 : 0;

                            setStepAndData({
                                acceptOrder: values,
                                sellOrderOverview: {
                                    uid: values.uid,
                                    flag: values.flag,
                                    tag: values.tag,
                                    projectImage: values.image,
                                    projectTitle: values.title,
                                    projectCity: values.city,
                                    expirationDate: <FormatDateWithLocale date={values.date} />,
                                    shares: parseInt(values.shares),
                                    pricePerShare: parseFloat(values.pricePerShare),
                                    sellingPrice: total,
                                    sellingFeePercent,
                                    sellingFee,
                                    totalSalesPrice: total + sellingFee,
                                    Document: values.Document,
                                },
                                OTP: {
                                    uid: values.uid,
                                    Shares: values.shares,
                                    ProjectID: router.query.id,
                                    TypeOrder: values.typeOrder,
                                    ExpirationDate: values.date,
                                    IsSellerPersonalInformationConfirmed: "true",
                                },
                                orderSuccess: {
                                    flag: values.flag,
                                    tag: values.tag,
                                    projectImage: values.image,
                                    projectTitle: values.title,
                                    projectCity: values.city,
                                    expirationDate: <FormatDateWithLocale date={values.date} />,
                                    shares: parseInt(values.shares),
                                    pricePerShare: parseFloat(values.pricePerShare),
                                    sellingPrice: total,
                                    sellingFeePercent,
                                    sellingFee,
                                    totalSalesPrice: total + sellingFee,
                                },
                            });
                            setStep("acceptOrder");
                            setOfferAccepted(true);
                            setTimeoutExtended(values.isTimeoutExtended);
                        }}
                        onCreateButtonClick={() => {
                            setBackSlideEffect("step-slide-left");
                            setStep("sellOrderForm");
                        }}
                    />
                );
            case "acceptOrder":
                return (
                    <AcceptOrder
                        minShareTypeWise={minShareTypeWise}
                        backSlideEffect={backSlideEffect}
                        userProjectShares={userProjectShares}
                        setCloseTitle={setCloseTitle}
                        stepData={orderStepData.acceptOrder}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("sellOrders");
                        }}
                        onForward={(values) => {
                            setBackSlideEffect("step-slide-left");

                            const total = parseInt(values.Amount);
                            const sellingFeePercent = 0;
                            const sellingFee = sellingFeePercent > 0 ? (sellingFeePercent * total) / 100 : 0;

                            setStepAndData({
                                sellOrderOverview: {
                                    ...orderStepData.sellOrderOverview,
                                    isOfferAccepted,
                                    uid: values.uid,
                                    tag: values.IsSplitAllowed === "true" ? `split-${values.TypeOrder}` : values.TypeOrder,
                                    shares: parseInt(values.AvailableShares),
                                    sellingPrice: total,
                                    sellingFeePercent,
                                    sellingFee,
                                    totalSalesPrice: total + sellingFee,
                                },
                                OTP: {
                                    ...orderStepData.OTP,
                                    uid: values.uid,
                                    Shares: values.AvailableShares,
                                    TypeOrder: values.TypeOrder,
                                },
                                orderSuccess: {
                                    ...orderStepData.orderSuccess,
                                    tag: values.IsSplitAllowed === "true" ? `split-${values.TypeOrder}` : values.TypeOrder,
                                    shares: parseInt(values.AvailableShares),
                                    sellingPrice: total,
                                    sellingFeePercent,
                                    sellingFee,
                                    totalSalesPrice: total + sellingFee,
                                },
                            });
                            setStep("sellOrderOverview");

                            // Set order timeout
                            ACCEPT_SPLIT_ORDER_TYPE.includes(values.TypeOrder) && setOrderTimeout(values.OrderTimeout);

                            // Set current order UID
                            setCurrentOrderUID(values.uid);
                        }}
                    />
                );
            case "adequacyProcess":
                return (
                    <RenderAdequacyStep
                        onAdequacyBack={() => {
                            setBackSlideEffect("step-slide-right");
                            isOfferAccepted ? setStep("sellOrders") : setStep("sellOrderForm");
                        }}
                        onWarningNext={() => {
                            setBackSlideEffect("step-slide-left");
                            isOfferAccepted ? setStep("sellOrderOverview") : setStep("walletOverview");
                        }}
                        isAccepted={isAccepted}
                        investSum={800}
                        isWithOrder
                        step={adequacyStep}
                        kycCompleted={isKycCompleted}
                        adequacyCompleted={isAdequacyCompleted}
                        setInvestmentStepData={setInvestmentStepData}
                        setAdequacyStart={setAdequacyStart}
                        userDashboardDetailsSuccess={userDashboardDetailsSuccess}
                        opne={open}
                    />
                );
            case "sellOrderForm":
                return (
                    <SellOrderForm
                        minShareTypeWise={minShareTypeWise}
                        backSlideEffect={backSlideEffect}
                        userProjectShares={userProjectShares}
                        projectOffers={projectOffers}
                        setCloseTitle={setCloseTitle}
                        maxInvestmentAmount={maxInvestmentAmount}
                        project={project}
                        stepData={orderStepData.sellOrderForm}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("sellOrders");
                        }}
                        projectTokenData={projectTokenData}
                        onForward={(values) => {
                            setBackSlideEffect("step-slide-left");

                            const total = parseInt(values.sellShares) * parseFloat(values.sellPricePerShare);
                            const sellingFeePercent = 0;
                            const sellingFee = sellingFeePercent > 0 ? (sellingFeePercent * total) / 100 : 0;
                            const expirationDate =
                                values.sellActiveDate &&
                                (values.sellActiveDate.value === "other"
                                    ? values.sellActiveOtherDate
                                    : values.sellActiveDate.value);

                            setStepAndData({
                                sellOrderForm: values,
                                sellOrderOverview: {
                                    isOfferAccepted,
                                    uid: values.uid,
                                    tag: values?.IsSplitAllowed === "true" ? `split-${values?.TypeOrder}` : values?.TypeOrder,
                                    flag: values.UserCountry,
                                    projectImage: project?.images?.teaserImage?.path,
                                    projectTitle: project?.title,
                                    projectCity: project?.address?.city,
                                    expirationDate: <FormatDateWithLocale date={expirationDate} />,
                                    shares: parseInt(values.sellShares),
                                    pricePerShare: parseFloat(values.sellPricePerShare),
                                    sellingPrice: total,
                                    sellingFeePercent,
                                    sellingFee,
                                    totalSalesPrice: total + sellingFee,
                                    Document: values.Document,
                                },
                                OTP: {
                                    uid: values.uid,
                                    Shares: values.sellShares,
                                    ProjectID: router.query.id,
                                    TypeOrder: ORDER_TYPE.SELL,
                                    ExpirationDate: expirationDate,
                                    IsSellerPersonalInformationConfirmed: "true",
                                },
                                orderSuccess: {
                                    tag: values?.IsSplitAllowed === "true" ? `split-${values?.TypeOrder}` : values?.TypeOrder,
                                    flag: values.UserCountry,
                                    projectImage: project?.images?.teaserImage?.path,
                                    projectTitle: project?.title,
                                    projectCity: project?.address?.city,
                                    expirationDate: <FormatDateWithLocale date={expirationDate} />,
                                    shares: parseInt(values.sellShares),
                                    pricePerShare: parseFloat(values.sellPricePerShare),
                                    sellingPrice: total,
                                    sellingFeePercent,
                                    sellingFee,
                                    totalSalesPrice: total + sellingFee,
                                },
                            });
                            // onInit(values);
                            setStep("sellOrderOverview");
                        }}
                    />
                );
            case "walletOverview":
                return (
                    <WalletOverview
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("adequacyProcess");
                        }}
                        onForward={() => {
                            setBackSlideEffect("step-slide-left");
                            setStep("sellOrderOverview");
                        }}
                    />
                );
            case "sellOrderOverview":
                return (
                    <SellOrderOverview
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        stepData={orderStepData.sellOrderOverview}
                        isOfferAccepted={isOfferAccepted}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            isOfferAccepted ? setStep("sellOrders") : setStep("sellOrderForm");
                        }}
                        onForward={() => {
                            setBackSlideEffect("step-slide-left");
                            setStep("OTP");
                        }}
                    />
                );
            case "OTP":
                return (
                    <OTP
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        isOfferAccepted={isOfferAccepted}
                        stepData={orderStepData.OTP}
                        onBack={() => {
                            setBackSlideEffect("step-slide-right");
                            setStep("sellOrderOverview");
                        }}
                        onCreate={(order) => onCreate(order)}
                        onForward={() => {
                            setBackSlideEffect("step-slide-left");
                            setStep("orderSuccess");
                            setTimerVisible(false);
                            // updateUserProjectShares(order?.Shares)
                        }}
                    />
                );
            case "orderSuccess":
                return (
                    <OrderSuccess
                        backSlideEffect={backSlideEffect}
                        setCloseTitle={setCloseTitle}
                        subHeading={
                            isOfferAccepted
                                ? formatMessage(messages.soSuccessOfferAcceptSubheading)
                                : formatMessage(messages.soSuccessSubheading)
                        }
                        lineBelowImage={
                            isOfferAccepted
                                ? formatMessage(messages.soSuccessOfferAcceptlineBelowImage)
                                : formatMessage(messages.soEditSuccesslineBelowImage)
                        }
                        buttonClass="btn-sell"
                        buttonText={formatMessage(messages.boEditSuccessButtonText)}
                        content={
                            isOfferAccepted ? (
                                <>
                                    <p>{formatMessage(messages.soSuccessOfferAcceptTitle)}</p>
                                    <p>{formatMessage(messages.soSuccessOfferAcceptContent)}</p>
                                </>
                            ) : null
                        }
                        orderItemData={{
                            className: "border-active-red",
                            tag: orderStepData.orderSuccess?.tag,
                            flag: orderStepData.orderSuccess?.flag,
                            image: orderStepData.orderSuccess?.projectImage,
                            title: orderStepData.orderSuccess?.projectTitle,
                            city: orderStepData.orderSuccess?.projectCity,
                            shares: orderStepData.orderSuccess?.shares,
                            price: orderStepData.orderSuccess?.sellingPrice,
                            date: orderStepData.orderSuccess?.expirationDate,
                            pricePerShare: orderStepData.orderSuccess?.pricePerShare,
                        }}
                        rowData={[
                            {
                                left: `${formatMessage(messages.sellingFee)} (${orderStepData.orderSuccess?.sellingFeePercent
                                    }%):`,
                                right: orderStepData.orderSuccess?.sellingFee,
                            },
                            {
                                left: formatMessage(messages.totalSalesPrice),
                                right: orderStepData.orderSuccess?.totalSalesPrice,
                            },
                        ]}
                        onBackToProperty={() => close()}
                    />
                );
            case "orderExpired":
                return <OrderExpired onButtonClick={() => close()} />;
            default:
                return (
                    <SellOrders
                        getBuyOrders={open}
                        setCloseTitle={setCloseTitle}
                        setOfferAccepted={setOfferAccepted}
                        setStepAndData={setStepAndData}
                        onAcceptOffer={() => {
                            setStep("acceptOrder");
                            setOfferAccepted(true);
                        }}
                        onCreateButtonClick={() => setStep("sellOrderForm")}
                    />
                );
        }
    };

    return (
        <SideModal
            className="sell-shares-modal"
            containerClassName="sell-share-modal-container"
            heading={closeTitle}
            timer={
                isTimerVisible ? (
                    <TimeOutCountDown
                        noText
                        showUnit
                        orderExpired={() => {
                            hideAddTimeBlock();
                            setStep("orderExpired");
                        }}
                        timeAboutToEnd={(check) => !timeoutExtended && setAddMoreTimeVisible(check)}
                        textClassName="secondary-light-color text-14"
                        className="text-14"
                        timeout={orderTimeout?.split("_")[1]}
                        expiryDate={orderTimeout?.split("_")[0]}
                    />
                ) : null
            }
            open={open}
            onCloseButtonClick={() => close()}
        >
            <>
                <div className="add-more-time bg-lighter-grey">
                    <CloseIcon className="close-icon" onClick={hideAddTimeBlock} />
                    <p className="text-14 pl-5 pt-5">
                        {formatMessage(messages.addMoreTimeTitle1)}
                        <TimeOutCountDown
                            noText
                            showUnit
                            textClassName="secondary-light-color text-14"
                            className="text-14"
                            timeout={orderTimeout?.split("_")[1]}
                            expiryDate={orderTimeout?.split("_")[0]}
                        />
                        {formatMessage(messages.addMoreTimeTitle2)}
                    </p>
                    <p className="text-16 mb-8 pl-5 pr-9">{formatMessage(messages.addMoreTimeContent)}</p>
                    <button
                        className={`ml-5 medium ${isAddTimeLoading ? "disable-grey" : ""}`}
                        disabled={isAddTimeLoading}
                        onClick={addMoreTime}
                    >
                        {isAddTimeLoading ? (
                            <>
                                <NewLoader /> {formatMessage(messages.addMoreTimeButtonText)}
                            </>
                        ) : (
                            formatMessage(messages.addMoreTimeButtonText)
                        )}
                    </button>
                </div>
                {renderStep(step)}
            </>
        </SideModal>
    );
};

const mapStateToProps = createStructuredSelector({
    adequacyStep: selectAdequacyStep,
    isAccepted: selectAdequacyIsAccepted,
    userDashboardDetails: selectUserDashboardDetails,
    currentKYCStatus: selectCurrenKYCStatus,
});

const mapDispatchToProps = (dispatch) => ({
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
    setAdequacyStart: (data) => dispatch(setAdequacyStart(data)),
    userDashboardDetailsSuccess: (data) => dispatch(userDashboardDetailsSuccess(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SellSharesModal);
